import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import uuidv1 from 'uuid/v1'

import ProtrackLevel from './ProTrackSection/ProtrackLevel'
import ProTrackSection from './ProTrackSection'

import './styles.scss'

const baseClass = 'onboarding-protracks-levels-section'

const renderPreviousProTrackSection = previousProTracks => {
  return previousProTracks.map(proTrack => <ProTrackSection proTrack={proTrack} />)
}

const renderNewProTracksSection = newProTrackLevels => {
  return newProTrackLevels.map(protrackLevel => (
    <ProtrackLevel protrackLevel={protrackLevel} key={uuidv1()} selectText={'Select'} />
  ))
}

const Section = ({ title, subtitle, newProTrackLevels, currentProTrack, previousProTracks }) => (
  <div className={`${baseClass}__section ${baseClass}__section--next`}>
    <div className={`${baseClass}__header`}>
      <div className={`${baseClass}__title`}>{title}</div>
      <div className={`${baseClass}__subtitle`}>{subtitle}</div>
    </div>
    {(currentProTrack.get('previousLevels').size || currentProTrack.get('nextLevel')) && (
      <ProTrackSection proTrack={currentProTrack} />
    )}
    {!!newProTrackLevels.size && renderNewProTracksSection(newProTrackLevels)}
    {!!previousProTracks.size && renderPreviousProTrackSection(previousProTracks)}
  </div>
)

Section.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  newProTrackLevels: ImmutablePropTypes.list.isRequired,
  currentProTrack: PropTypes.object.isRequired,
  previousProTracks: ImmutablePropTypes.list.isRequired,
}

export default Section
